import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

const BasicRadioGroup = ({ choices, onChange, defaultValue }) => {
  return (
    <RadioGroup
      aria-labelledby="active-radio-buttons-group-label"
      defaultValue={defaultValue}
      row
      name="radio-buttons-group"
      onChange={onChange}
    >
      {choices.map((choice, key) => (
        <FormControlLabel
          key={key}
          value={choice.value}
          control={<Radio />}
          label={choice.label}
        />
      ))}
    </RadioGroup>
  );
};

export default BasicRadioGroup;
